import { Skeleton } from '@mui/joy'
import { useRentalContractMachineContext } from '~/entities/common/RentalContract'
import { ChipStatus } from '~/shared/ui/Chips'

type StatusProps = {
  isLoading: boolean
}

export function Status({ isLoading }: StatusProps) {
  const { meta } = useRentalContractMachineContext()

  return (
    <ChipStatus
      data-testid='rental-contract-status'
      loading={
        isLoading && <Skeleton sx={{ top: 0, left: 0, minWidth: '100px' }} />
      }
      labelI18n={meta.label}
      variant={meta.color}
      sx={{ minWidth: '100px', marginBottom: '6px', textAlign: 'center' }}
    />
  )
}
